import { Box, Paper, Typography, Divider } from '@mui/material'
import React from 'react'

interface PremiumSectionProps {
  title: string
  subtitle?: string
  id?: string
  children: React.ReactNode
  noPaper?: boolean
}

const PremiumSection: React.FC<PremiumSectionProps> = ({
  title,
  subtitle,
  id,
  children,
  noPaper = false
}) => {
  const headerContent = (
    <Box
      sx={{
        background: 'linear-gradient(90deg, rgba(226,90,11,0.15) 0%, transparent 100%)',
        borderLeft: '4px solid #e25a0b',
        pl: 2,
        py: 1,
        mb: 2
      }}
    >
      <Typography
        variant='h5'
        fontWeight='bold'
        textTransform='uppercase'
        color='primary'
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant='subtitle2' color='text.secondary'>
          {subtitle}
        </Typography>
      )}
    </Box>
  )

  if (noPaper) {
    return (
      <Box id={id} sx={{ mb: 4 }}>
        {headerContent}
        {children}
      </Box>
    )
  }

  return (
    <Paper
      elevation={3}
      id={id}
      sx={{
        p: 3,
        borderRadius: 2,
        border: '1px solid rgba(226,90,11,0.1)',
        mb: 4,
        '&:hover': { boxShadow: 6 }
      }}
    >
      {headerContent}
      {children}
    </Paper>
  )
}

export default PremiumSection
